module.exports = __webpack_public_path__ + "media/images/animations/wide_loads/4-1ab87de4a092aafb7085666fd74e7dc5.png";